import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subscription, Subject } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import {  Access, UserAccess } from '../models/userModel';
import { StorageConstants, API } from '../utility/constants';
import { isString } from 'lodash';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class BaseService {
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {}

    public get<T>(action: string, fromObject: any = null): Observable<any> {
      return this.http
          .get(this.config.getConfig('rootUrl') + action, { params: new HttpParams({fromObject}) })
          .map(this.checkResults)
          .catch(this.handleErrorObservable);
    }

    private post<T>(action: string, body: any, isToken = true): Observable<T> {
      return this.http
          .post(this.config.getConfig('rootUrl') + action, body)
          .map(res => res as T)
          .catch(this.handleErrorObservable);
    }

    private checkResults(res: any) {
      if (!res || res === '') {
          return true;
      } else {
          return res;
      }
    }

    private getParams(obj): HttpParams {
      return  new HttpParams({fromObject: obj});
    }

    public httpgettext(action: string, params: any = null): Promise<string> {
      return this.http
          .get(this.config.getConfig('rootUrl') + action , { params: this.getParams(params), responseType: "text" })
          .toPromise()
          .then(res => res as string)
          .catch(this.handleErrorPromise);
    }

    public httpget<T>(action: string,  params: any = null ): Promise<T> {
      return this.http
          .get(this.config.getConfig('rootUrl') + action , { params: this.getParams(params) })
          .toPromise()
          .then(res => res as T)
          .catch(this.handleErrorPromise);
    }

    public httpgetblob<T>(action: string, params : any = null): Promise<any> {
      return this.http
          .get(this.config.getConfig('rootUrl') + action, { responseType: 'blob', params: this.getParams(params)} )
          .toPromise()
          .then(res => res)
          .catch(err => alert('Something went wrong. Error message: ' + err));
    }

    public httppostblob<T>(action: string, body : any): Promise<any> {
      return this.http
          .post(this.config.getConfig('rootUrl') + action, body, { responseType: 'blob' })
          .toPromise()
          .then(res => res as T)
          .catch(err => alert('Something went wrong. Error message: ' + err));
    }

    public httppost<T>(action: string, body: any): Promise<T> {
      return this.http
          .post(this.config.getConfig('rootUrl') + action, body)
          .toPromise()
          .then(res => res as T)
          .catch(this.handleErrorPromise);
    }

    public httpput<T>(action: string, body: any): Promise<T> {
      return this.http
          .put(this.config.getConfig('rootUrl') + action, body)
          .toPromise()
          .then(res => res as T)
          .catch(this.handleErrorPromise);
    }

    public getAccessRefresh(): Observable<Access> {
      return  this.get<Access>('/user/groups')
      .map(response => {
          let access =  <Access>response;
          sessionStorage.setItem(StorageConstants.Access, JSON.stringify(access));
            return access;
      });
    }

    public getAccess(): Observable<Access> {
      let access =  sessionStorage.getItem(StorageConstants.Access);
      if (access) { return Observable.create( (observer) =>  observer.next( JSON.parse(access))); }
      return this.getAccessRefresh();
    }

    public setUserAccess(userAccess: UserAccess): Observable<UserAccess> {
      return this.post(API.SetUserAccess, userAccess);
    }

    protected handleErrorPromise = (error: any = null) => {
      if (!error) return Promise.reject('unknown error');

      this.handleError(error);

      return Promise.reject(error.message || error);
    }

    protected handleErrorObservable = (error: any = null) => {
      if (!error) return Promise.reject('unknown error');

      this.handleError(error) ;

      return Observable.throw(error.message || error) ;
    }

    protected handleError = (error) => {
      if (error.status === 400 && error && error.error) {
        let message = '';
        
        if(isString(error.error)) { message += error.error; }

        if( error.error.ModelState || error.error.Message){
          if (error.error.Message ) { message += error.error.Message; }
          
          // tslint:disable-next-line:forin
          for ( let propertyName in  error.error.ModelState) {
            message += error.error.ModelState[propertyName];
          }
        }
        console.error(message);
        alert(message);
      } else {
        console.error(error);
        this.appInsights.logError(error);
        alert('An error occurred in the service call. Please try again.  If the issue continues, please contact support.');
      }
    }
}